import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propStringify'
})
export class PropStringifyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return JSON.stringify(value);
  }

}
